import { useQuery, useQueryClient } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchTableItems } from "../Services/fetchTableItems";

export default function useTableItems({ tableName, countryId }) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: ["serviceOperation", "tableItems", { tableName, countryId }],
    queryFn: () => fetchTableItems({ accessToken, tableName, countryId }),
    staleTime: 0,
    enabled: !!tableName && !!countryId && !!accessToken,
    retry: false,
  });
}

export function useInvalidateTableItems() {
  const queryClient = useQueryClient();
  return (tableName, countryId) =>
    queryClient.invalidateQueries({
      queryKey: ["serviceOperation", "tableItems", { tableName, countryId }],
    });
}